import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Select, Switch, Space, message, Popconfirm, Tag } from 'antd';
import { PlusOutlined, ReloadOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import api from '../utils/api';
import { useMenuPermission } from '../hooks/useMenuPermission';

function ApiOpenKeys() {
  const { canEdit } = useMenuPermission();
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editing, setEditing] = useState(null);
  const [newKey, setNewKey] = useState(null);
  const [form] = Form.useForm();

  const load = async () => {
    try { const r = await api.get('/api-open/keys'); if (r.code === 200) setData(r.data); } catch (e) {}
  };
  const loadUsers = async () => {
    try { const r = await api.get('/users', { params: { pageSize: 1000 } }); if (r.code === 200) setUsers(r.data.list || []); } catch (e) {}
  };
  useEffect(() => { load(); loadUsers(); }, []);

  const handleAdd = () => { setEditing(null); setNewKey(null); form.resetFields(); setModalVisible(true); };
  const handleEdit = (r) => { setEditing(r); setNewKey(null); form.setFieldsValue({ name: r.name, user_id: r.user_id }); setModalVisible(true); };
  const handleSave = async () => {
    try {
      const v = await form.validateFields();
      if (editing) { await api.put(`/api-open/keys/${editing.id}`, v); message.success('更新成功'); }
      else { const r = await api.post('/api-open/keys', v); if (r.code === 200) { message.success('创建成功'); setNewKey(r.data.api_key); } }
      setModalVisible(false); load();
    } catch (e) {}
  };
  const handleToggle = async (r) => { await api.put(`/api-open/keys/${r.id}`, { enabled: r.enabled?0:1 }); load(); };
  const handleRegenerate = async (r) => {
    const res = await api.post(`/api-open/keys/${r.id}/regenerate`);
    if (res?.code === 200) { setNewKey(res.data.api_key); load(); }
  };
  const handleDelete = async (id) => { await api.delete(`/api-open/keys/${id}`); load(); };

  const cols = [
    { title: 'ID', dataIndex: 'id', width: 50 },
    { title: '名称', dataIndex: 'name', width: 120 },
    { title: 'API Key', dataIndex: 'api_key', width: 280, ellipsis: true },
    { title: '关联用户', dataIndex: 'user_name', width: 140, render: (v, r) => v ? <span>{v}{r.user_role === 'supplier' ? <Tag color="blue" style={{marginLeft:4}}>主体</Tag> : <Tag color="orange" style={{marginLeft:4}}>管理员</Tag>}</span> : '-' },
    { title: '启用', dataIndex: 'enabled', width: 80, render: (v, r) => canEdit ? <Switch checked={v===1} onChange={() => handleToggle(r)} /> : <Tag color={v?'green':'red'}>{v?'启用':'禁用'}</Tag> },
    { title: '操作', width: 240, render: (_, r) => canEdit ? <Space>
      <Button size="small" icon={<EditOutlined />} onClick={() => handleEdit(r)}>编辑</Button>
      <Button size="small" icon={<ReloadOutlined />} onClick={() => handleRegenerate(r)}>刷新Key</Button>
      <Popconfirm title="确定删除？" onConfirm={() => handleDelete(r.id)}><Button size="small" danger icon={<DeleteOutlined />} /></Popconfirm>
    </Space> : null }
  ];

  return (
    <div>
      <h3 style={{ margin: '0 0 16px 0' }}>Key管理</h3>
      {canEdit && <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd} style={{ marginBottom: 16 }}>新增Key</Button>}
      {newKey && <div style={{ marginBottom: 16, padding: 12, background: '#f6ffed', borderRadius: 6, border: '1px solid #b7eb8f' }}>新Key：<strong>{newKey}</strong>（请复制保存，关闭后不可见）</div>}
      <Table rowKey="id" columns={cols} dataSource={data} pagination={false} size="small" />
      <Modal title={editing?'编辑Key':'新增Key'} open={modalVisible} onOk={handleSave} onCancel={() => setModalVisible(false)}>
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="Key名称" rules={[{ required: true }]}><Input placeholder="如：星辰专用Key" /></Form.Item>
          <Form.Item name="user_id" label="关联用户" rules={[{ required: true }]}>
            <Select placeholder="选择用户" options={users.filter(u => u.username !== 'admin').map(u => ({ label: `${u.name} (${u.username}) - ${u.role==='supplier'?'主体':'管理员'}`, value: u.id }))} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default ApiOpenKeys;
